import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import SortIcon from "@mui/icons-material/Sort";
import styles from "../../styles/common/sortMenu.module.css";
import { underscoreToCap } from "../../lib/util";

const options = [
  "fund_id",
  "amount_requested",
  "proposal_name",
  "rating",
  "result_votes",
];
const NoFundOptions = [
  "amount_requested",
  "proposal_name",
  "rating",
  "result_votes",
];

type SortSearchProps = {
  sortPage: Function;
  hideFund: boolean;
};

const ProposalSortMenu = (props: SortSearchProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [sortData, setSortData] = React.useState<{
    order_by: string;
    ordering: string;
  }>({ order_by: "proposal_name", ordering: "asc" });

  React.useEffect(() => {
    props.sortPage(sortData);
    //eslint-disable-next-line
  }, [sortData]);

  const [showUpArrow, setShowUpArrow] = React.useState<boolean>(true);
  const [showDownArrow, setShowDownArrow] = React.useState<boolean>(false);

  const handleArrowClick = () => {
    setShowUpArrow((prevState) => !prevState);
    setShowDownArrow((prevState) => !prevState);
    setSortData({
      ...sortData,
      ordering: sortData.ordering === "asc" ? "desc" : "asc",
    });
  };


  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (option: string) => {
    setAnchorEl(null);
    setSortData({
      ...sortData,
      order_by: option,
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <ButtonGroup
      variant="text"
      aria-label="text button group"
      className={styles.buttonGroup}
    >
      <List>
        <ListItem
          id="lock-button"
          aria-haspopup="listbox"
          aria-controls="lock-menu"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClickListItem}
          className={styles.listItem}
        >
          <SortIcon color="primary" />
          <ListItemText
            primary={underscoreToCap(sortData.order_by)}
            className={styles.listItemText}
          />
        </ListItem>
      </List>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        {!props.hideFund &&
          options.map((option, index) => (
            <MenuItem
              key={option}
              selected={option === sortData.order_by}
              onClick={() => handleMenuItemClick(option)}
            >
              {underscoreToCap(option)}
            </MenuItem>
          ))}
        {props.hideFund &&
          NoFundOptions.map((option, index) => (
            <MenuItem
              key={option}
              selected={option === sortData.order_by}
              onClick={() => handleMenuItemClick(option)}
            >
              {underscoreToCap(option)}
            </MenuItem>
          ))}
      </Menu>
      <IconButton
        size="small"
        sx={{ display: showUpArrow ? "Inline" : "None" }}
        onClick={handleArrowClick}
      >
        <ArrowUpwardIcon fontSize="small" color="primary" />
      </IconButton>

      <IconButton
        size="small"
        sx={{ display: showDownArrow ? "Inline" : "None" }}
        onClick={handleArrowClick}
      >
        <ArrowDownwardIcon fontSize="small" color="primary" />
      </IconButton>
    </ButtonGroup>
  );
};

export default ProposalSortMenu;
